function i(t) {
  var e;
  return (e = t.headerMeta.metaActions) == null ? void 0 : e.find((n) => n.text === "Mein Bereich");
}
export {
  i as getLoginLink
};
